'use client';

import { usePathname } from 'next/navigation';
import NextLink from 'next/link';
import { isActivePath } from '../../Header.utils';
import { mobileNavItemStyles } from './MobileNavItem.styles';
import { css, cx } from '@onbeam/business-styled-system/css';
import { flex } from '@onbeam/business-styled-system/patterns';
import { useDisclosure } from '@onbeam/utils';
import { MobileSubNav } from '../MobileSubNav';
import { useMobileNavigation } from '../MobileNavigation.store';
import { NavItem } from '../../Header.types';
import { SubNavItem } from '../../SubNavItem';
import { ArrowDiagonalIcon, ChevronRightIcon } from '@onbeam/icons/business';

export const MobileNavItem = ({
  label,
  href,
  isExternal,
  subMenu,
}: NavItem) => {
  const pathname = usePathname();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleClose = () => {
    onClose();
    useMobileNavigation.setState({ isOpen: false });
  };

  const Item = href ? (
    <NextLink
      href={href}
      target={isExternal ? '_blank' : '_self'}
      rel="noopener noreferrer"
      data-active={isActivePath(pathname, href)}
      className={mobileNavItemStyles}
      onClick={isExternal ? undefined : handleClose}
    >
      <span>{label}</span>
      {isExternal && (
        <ArrowDiagonalIcon
          className={css({
            flexShrink: 0,
          })}
        />
      )}
    </NextLink>
  ) : (
    <button
      type="button"
      onClick={onOpen}
      className={cx(mobileNavItemStyles, flex({ justify: 'space-between' }))}
    >
      <span>{label}</span>
      <ChevronRightIcon className={css({ flexShrink: 0 })} />
    </button>
  );

  if (!subMenu) return Item;

  // Socials have their separate styles on mobile
  if (subMenu.variant === 'compact') return null;

  return (
    <>
      {Item}
      <MobileSubNav isOpen={isOpen} onClose={onClose}>
        {subMenu?.items.map((item) => (
          <SubNavItem
            {...item}
            variant={subMenu.variant}
            key={item.label}
            alwaysShowIcon
            onClick={item.isExternal ? undefined : handleClose}
          />
        ))}
      </MobileSubNav>
    </>
  );
};
